import React from 'react';
import { Button, Dialog, Grid } from 'pcln-design-system';
import { ArrowLeft } from 'pcln-icons';
import styled from 'styled-components';
const FlexButton = /*#__PURE__*/styled(Button).withConfig({
  displayName: "InputModal__FlexButton",
  componentId: "sc-knyk0y-0"
})(["&&&{display:flex;justify-content:center;align-items:center;padding:0;}&:focus-visible{box-shadow:none;}"]);
/** @public */
const InputModal = ({
  children,
  footer,
  dialogProps,
  id,
  input,
  inputProps,
  isOpen,
  subheading,
  zIndex,
  onClose
}) => {
  function handleClose() {
    onClose(false);
  }
  return React.createElement(Dialog, {
    ariaDescription: id,
    ariaTitle: `Input Modal - ${id}`,
    footerContent: footer,
    headerContent: React.createElement(React.Fragment, null, React.createElement(Grid, {
      "data-testid": 'input-header',
      alignItems: inputProps?.alignItems,
      templateColumns: 'auto 1fr',
      templateRows: '1fr auto',
      width: 1
    }, React.createElement(FlexButton, {
      "aria-label": 'Close',
      borderRadius: 'full',
      boxShadowSize: 'sm',
      height: '40px',
      width: '40px',
      mr: '12px',
      size: 'large',
      variation: 'white',
      onClick: handleClose
    }, React.createElement(ArrowLeft, {
      color: 'primary'
    })), React.cloneElement(input, {
      autoFocus: true,
      width: 1
    })), subheading),
    headerContentProps: {
      templateColumns: '1fr',
      ...inputProps
    },
    innerContentOverflow: 'hidden',
    open: isOpen,
    showCloseButton: false,
    showScrollShadow: true,
    sheet: true,
    size: 'full',
    ...dialogProps,
    zIndex: zIndex,
    onOpenChange: onClose
  }, children);
};
export default InputModal;